import SimpleAddMemberModal from "./SimpleAddMemberModal";
export default SimpleAddMemberModal;
